module.exports = __webpack_public_path__ + "img/hand_3_on.bdab532c.svg";